import React, { useEffect, useState } from "react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import ProblemSolution from "../components/landing/ProblemSolution";
import HowItWorks from "../components/landing/HowItWorks";
import Benefits from "../components/landing/Benefits";
import Screenshots from "../components/landing/Screenshots";
import FAQ from "../components/landing/FAQ";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import ExitIntentPopup from "../components/landing/ExitIntentPopup";
import ScrollProgressBar from "../components/landing/ScrollProgressBar";
import Marquee from "../components/landing/Marquee";
import Maintenance from "../components/Maintenance";
import { getMaintenanceStatus } from "../lib/maintenance";
import "../styles/landing.css";

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);
  const [maintenance, setMaintenance] = useState({ enabled: false, message: '' });
  const [checkingMaintenance, setCheckingMaintenance] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Dark theme is now the default across the whole app (landing + legal
  // pages), so no per-page scoping is needed.

  useEffect(() => {
    const checkMaintenance = async () => {
      const status = await getMaintenanceStatus();
      setMaintenance(status);
      setCheckingMaintenance(false);
    };
    checkMaintenance();
  }, []);

  // Show maintenance screen if enabled
  if (maintenance.enabled) {
    return <Maintenance message={maintenance.message} />;
  }

  // Don't render anything while checking (prevents flash)
  if (checkingMaintenance) {
    return null;
  }

  return (
    <div className="landing-page">
      <ScrollProgressBar />
      <Header scrolled={scrolled} />
      <main>
        <HeroSection />
        <Marquee />
        <ProblemSolution />
        <HowItWorks />
        <Benefits />
        <Screenshots />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <ExitIntentPopup />
    </div>
  );
}
